import { Inject, Injectable } from '@angular/core';
import { JSBridgeService } from './jsbridge.service';
import { PlatformDetect } from '@libs/platform/platform-detect';
import { FactoryService } from './factory.service';
import { ComRouteService } from './com-route.service';
import { TrackingInterface, SH_TRACKING} from '@libs/tracking';
import { AccountService } from './account.service';
import { bussinessCodeMap } from '@core/libs/config/profile-mapping';
import { CONFIG_OPTIONS, ConfigInterface } from '@core/libs/config/config-options';

@Injectable({
  providedIn: 'root'
})
    
export class ComActionService {
  private defaultURL: string;

  constructor( 
    private jsBridgeSer: JSBridgeService,
    private platform: PlatformDetect,
    private factorySer: FactoryService,
    private comRoute: ComRouteService,
    private acctSer: AccountService,
    @Inject(CONFIG_OPTIONS) private config: ConfigInterface,
    @Inject(SH_TRACKING) private trackIn: TrackingInterface
  ) {
    const origin = window.location.origin;
    this.defaultURL = this.platform.isWeb() ? this.config.getWebMainUrl(this.factorySer.language) : `${origin}${this.factorySer.wxHome}`; //default returnUrl after close profile project
  }

  public hideCloseBtn() { 
    if (this.platform.isApp() && window?.DisneyJSBridge) {
      this.jsBridgeSer.callJSBridge('changeCloseBtnStatus', { data: { hidden: true } }), res => { 
        console.log('changeCloseBtnStatus res..', res);
      };
    }
  }

  public routeURLCheck(targetUrl: string): void { 
    if (this.platform.isApp()) {
      this.jsBridgeSer.routeWithURL(`wdpr-shdr://weblink?url=${targetUrl}`);
    } else if (this.factorySer.isWebStyle) {
      // web端为打开新tab页
      window.open(targetUrl);
      return;
    } else {
      location.href = targetUrl;
    }
  }

  public async checkLoginAction(res: any, lgType: string) {
    if (res?.code !== '0') { 
      this.setLoginTrack(lgType, res, true);
    }
    switch (res?.code) { 
      case '0':
        this.factorySer.setLoginStatus(true);
        this.acctSer.token = res?.data?.token?.accessToken;
        await this.acctSer.getOaFans();
        await this.acctSer.getApHolder();
        await this.trackIn.setUserTrack(res.data);
        if (this.platform.isApp()) {
          const succ = await this.setSwid(res?.data);
          if (succ) {
            this.checkMember(res?.data, lgType, res);
          }
        } else { 
          this.checkMember(res?.data, lgType, res);
        }
        break;
      case '0305BBG08': // account has been suspend 0305B0212
        this.factorySer.setSinglePop(false, 'Profile.Common.Popup.Desc.Account.Suspend');
        break;
      case '0305BBG07': // account has been locked
        this.factorySer.setSinglePop(false, 'Profile.Common.Popup.Desc.Account.Locked');
        break;
      case '0305BBG01': //account not exit 
      case '0305BBG11': //account/pwd not match
      case '0305BBG06': //login account haven't sent password
      case '0304BO005': //faceid password not exit 
        this.factorySer.setSinglePop(false,
          lgType === 'phonePwd' ? 'Profile.Login.Phone.NoMatch.Err' : 'Profile.Login.Email.NoMatch.Err');
        break;
      case '0305BBG03': // legacy account need verify by pinCode
        return;
      case '0305BBG05': // value is used ( CSP is to do register )
        this.factorySer.setSinglePop(false, 'Profile.Login.CSP.Popup.Desc.Repeat.Registration');
        break;
      default:
        this.factorySer.setSinglePop();
        break;
    }
  }

  //set correct swid in case of tracking swid being overwritten by incorrect swid in the app 
  private async setSwid(data: any) { 
    const res = await this.jsBridgeSer.callJSBridge('setSwid', { swid: data?.swid });
    if (res?.resultCode === 0) {
      return true;
    } else { 
      console.log('setSwid res..',res);
      this.factorySer.setSinglePop();
      return false
    }
  }

  /**
   * @param keepLoginPage 
   * true: keep login page in native
   * false: native will close webView after logged
   * 
   * 1. register: keep true, then close webView by profile
   * 2. login and un-complete info: keep true, then close webView by profile
   * 3. login:
   *    have returnlUrl: keep true, return to returnlUrl
   *    no returnUrl: keep false (close webView by native)
   */
  private async saveToken(data: any, keepPage?: boolean) { 
    if (this.platform.isApp) { 
      if(keepPage) data['keepLoginPage'] = true;
      this.jsBridgeSer.callJSBridge('loginSuccessV2', {data: data});
    }
  }

  public checkMember(data: any, lgType: string, res: any) {
    this.factorySer.setSWID(data.swid);
    this.factorySer.tokenInfo = data;
    this.factorySer.isMember = true;
    sessionStorage.setItem('isMember', 'true');
    sessionStorage.removeItem('contactData'); //remove session data when multiplayer do login
    if (data?.registerDuringLogin) {
      const selectIterms = this.factorySer.getSessionInfo('selectIterms', true);
      this.trackIn.setTracking({
        event: 'registration',
        contact_option: selectIterms?.notice? 'shdr_yes' : 'shdr_no'
      }, true);
      this.saveToken(data, true);
      this.factorySer.isRegister = true;
      sessionStorage.setItem('tokenInfo', JSON.stringify(data));
      sessionStorage.removeItem('memberInfo');
      this.comRoute.route('/register');
    } else { 
      this.setLoginTrack(lgType, res);
      //becameMember means the customer is new register
      sessionStorage.removeItem('isRegister');
      if (data && data?.becameMember && (!data?.countrySet || !data?.dateOfBirthSet)) {
        this.saveToken(data, true);
        this.factorySer.isUpMember = true;
        this.factorySer.mberNoCountry = !data?.countrySet;
        this.factorySer.mberNoBirth = !data?.dateOfBirthSet;
        const info = {
          isUpMember: true,
          noCountry: !data?.countrySet,
          noBirth: !data?.dateOfBirthSet
        }
        sessionStorage.setItem('memberInfo', JSON.stringify(info));
        this.comRoute.route('/register');
      } else { 
        this.routingCheck(data, true, lgType);
      }
    }
  }

  /* use for login success routing, the logic as below:
    1.have return_url: routing to return_url
    2.no return_url:
      app: closeHybridView (return to my-center dashboard)
      minip: routing back to previous page
      wechat: routing back entry point dialog box
      web: routing to home page
    3.syncApp: sync login success for APP
    4.completeFlag: use for check if routingCheck from complete-info page
  */

  /**
   * @param tokenInfo token信息
   * @param syncApp 登录态是否同步搭配app
   * @param lgType 登录方式
   * @param hisPage 返回历史页面数
   */
  public routingCheck(tokenInfo: any = null, syncApp: boolean = false, lgType: string ='', hisPage?: number) {
    const loginData = tokenInfo || this.factorySer.tokenInfo;
    const mberFlag = sessionStorage.getItem('mberFlag') === 'true';
    // use for member flow
    if (mberFlag) {
      if (syncApp) this.saveToken(tokenInfo, true);
      this.factorySer.setLoginStatus(true);
      // check history page number
      let pageNum = hisPage || (lgType === 'legacyPhonePin' ? 3 : (lgType === 'phonePin' ? 2 : 1));
      if (this.factorySer.completeFlag) {
        pageNum++;
        this.factorySer.completeFlag = false;
      }
      history.go(-pageNum);
      return;
    }
    const rtUrl = this.factorySer.getReturnUrl();
    console.log('routingCheck rtUrl..', rtUrl);
    if (this.platform.isApp()) {
      if (syncApp) {
        this.saveToken(tokenInfo, rtUrl ? true : false);
        if (rtUrl) location.replace(rtUrl);
      } else { 
        rtUrl? location.replace(rtUrl) : this.jsBridgeSer.callJSBridge('closeHybridView', {});
      }
    } else { 
      if (rtUrl) {
        this.returnRouting(rtUrl, loginData);
      } else { 
        if (this.platform.isMiniP()) {
          this.postData(loginData);
          const delta = this.factorySer.delta;
          console.log('routingCheck delta..',delta);
          wx.miniProgram.navigateBack({ delta: delta > 1 ? delta : 1 });
        } else { 
          this.timeoutRoute(this.defaultURL);
        }
      }
    }
  }

  public async deleteRouting() { 
    this.factorySer.clearLogInfo();
    const tempUrl = this.factorySer.getReturnUrl();
    const rtUrl = (tempUrl && tempUrl !== '' && tempUrl !== 'null' && tempUrl !== 'undefined')? decodeURIComponent(tempUrl): null;
    console.log('deleteRouting rtUrl..', rtUrl);
    if (this.platform.isApp()) {
      if(this.platform.isDisneyIOS()) {
        this.jsBridgeSer.callJSBridge('clearBiometric');
      }
      // 删除账户后，清除登录态并回到app
      this.jsBridgeSer.callJSBridge('logoutSuccess', {}, res => {
        console.log('logoutSuccess...', res);
      });
    } else { 
      if (this.factorySer?.delta && this.platform.isMiniP()) {
        wx.miniProgram.postMessage({ data: 'userDeleted' })
        wx.miniProgram.navigateBack({ delta: this.factorySer.delta });
        return;
      }
      if (rtUrl) {
        this.returnRouting(rtUrl, null, true)
      } else { 
        this.comRoute.route('login', false, {replaceUrl: true});
      }
    }
  }

  private returnRouting(rtUrl: string, loginData: any, toLogin?: boolean) {
    const pattern = /^https?:\/\//;
    const match = pattern.test(rtUrl);
    if (match) {
      this.timeoutRoute(rtUrl);
    } else { 
      if (this.platform.isMiniP()) {
        if(loginData) this.postData(loginData);
        wx.miniProgram.reLaunch({ url: rtUrl});
      } else { 
        if (toLogin) {
          this.comRoute.route('login', false, { replaceUrl: true });
        } else { 
          this.timeoutRoute(this.defaultURL);
        }
      }
    }
  }

  // 延时跳转增加tracking上报成功率
  private timeoutRoute(url) {
    let timmer = setTimeout(() => {
      location.replace(url);
      clearTimeout(timmer);
      timmer = null;
    }, 500);
  }

  public logoutRouting() { 
    this.factorySer.clearLogInfo();
    if (this.platform.isApp()) {
      // 登出后，清除登录态并回到app
      this.jsBridgeSer.callJSBridge('logoutSuccess', {}, res => {
        console.log('logoutSuccess...', res);
      });
    } else {
      // mo清除登录态回到returnUrl
      if(this.factorySer.getBusiness() === bussinessCodeMap.MO && this.factorySer.returnUrl) {
        location.href = this.factorySer.returnUrl;
        return;
      }
      if (this.platform.isMiniP()) {
        wx.miniProgram.postMessage({ data: 'userLogout' });
        wx.miniProgram.navigateBack({ delta: 1 });
      } else { 
        this.comRoute.route('login', false, {replaceUrl: true});
      }
    }
  }

  private postData(loginData: any) { 
    let resp = {};
    if (loginData && this.factorySer.isPostMsg) { 
      resp = loginData?.token;
      resp['swid'] = loginData?.swid;
    }
    wx.miniProgram.postMessage({
      data: resp
    });
  }

  private setLoginTrack(lgType: string, res: any, errFlag?: boolean) {
    const selectIterms = this.factorySer.getSessionInfo('selectIterms', true);
    this.trackIn.setTracking({
      event: 'log_in_result',
      contact_option: selectIterms?.notice? 'shdr_yes' : 'shdr_no',
      is_success: res?.code === '0' ? 'yes' : 'no',
      login_type: this.factorySer.getLoginType(lgType),
      login_account: 'mobile',
      is_faceid_enabled: this.factorySer.getfaceIdEnable(),
      fail_reason: res?.code === '0' ? 'NA' : `${res?.code}_${res?.msg}`
    }, true);
    if (errFlag) { 
      this.trackIn.setTracking({
        event: 'error_msg',
        screen_type: 'login',
        page_name: 'tools/login/account',
        error_content: `${res?.code}_${res?.msg}`,
      });
    }
  }

}
